module.exports = __webpack_public_path__ + "img/las_vegas_3.084426d0.jpg";